import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components

import { Text } from '@beef/ui-kit';
import { isStringEmpty, replaceString } from '../../../../util';

// Styles

import styles from './styles.pcss';

const cx = classNames.bind(styles);

const BaseDescription = ({ value, description }) => (
  <div className={cx('description-container')}>
    {value && !isStringEmpty(value) ? (
      <span className={cx('description-container__value')}>
        <Text size="size6-m">
          {value}
        </Text>
      </span>
    ) : (
      <Text size="size6-r">
        {replaceString(description)}
      </Text>
    )}
  </div>
);

BaseDescription.propTypes = {
  value: PropTypes.string,
  description: PropTypes.string,
};

export { BaseDescription };
